import Recipe from "./Recipe";

export default Recipe;
